import type { SessionContext } from "../api/types";

export const LEADCAT_COMMERCE_FEATURE = "LEADCAT_COMMERCE";

export function hasCommerceAdminAccess(
  session: Pick<SessionContext, "features" | "featureTenantId" | "user" | "workspaceProduct">,
): boolean {
  if (session.workspaceProduct === "SIMPLE_BILLING") return false;
  if (!Array.isArray(session.features) || !session.features.includes(LEADCAT_COMMERCE_FEATURE)) return false;
  if (!["owner", "manager", "super_admin"].includes(session.user.role)) return false;
  return session.user.role !== "super_admin" || Boolean(session.featureTenantId);
}

export function hasCatalogReplyActivityAccess(
  session: Pick<SessionContext, "features" | "user" | "workspaceProduct">,
): boolean {
  if (session.workspaceProduct === "SIMPLE_BILLING") return false;
  if (!Array.isArray(session.features) || !session.features.includes(LEADCAT_COMMERCE_FEATURE)) return false;
  return ["owner", "manager", "staff"].includes(session.user.role);
}
